import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, from } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { UserFormActions } from '../user-form-actions';
import { MatDialog } from '@angular/material/dialog';
import { GlobalFlagsService } from '../../../services/global-flags.service';
import { UserService } from '../../../services/user.service';
import { LocationService } from '../../../services/location.service';
import { RegistrationService } from '../../../services/registration.service';
import { DialogComponent } from '../../commons/dialog/dialog.component';
import { passwordErrorsArray } from '../../../commons/config';
import { DialogChangePassword } from '../../commons/dialog-change-password/dialog-change-password.component';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit {

  @Input('formContent') formContent: any;
  @Input('action') action: UserFormActions;
  @Output() onSubmitSuccess = new EventEmitter<boolean>();

  readonly CUSTOM_FIELD_REQUIRED = 1;
  readonly CUSTOM_FIELD_DISABLE = 2;
  readonly CUSTOM_FIELD_HIDE = 3;

  testToggle = '1';
  userDetails;
  diagnosticsArray: any;
  countries: any;
  states: any;
  regions: any;
  modifyPasswordString: any;
  languages: any;
  usernameExists: boolean;
  disableStates: boolean;
  passwordRules = passwordErrorsArray;

  get modifyPassword() {
    return this.modifyPasswordString === 'true' ? true : false;
  }

  get registerAction() {
    return this.action === UserFormActions.Register;
  }

  get passwordIsEmpty() {
    return (this.userDetails.secMemberships[0].password === '' && this.modifyPassword);
  }

  get username() {
    return JSON.parse(localStorage.getItem('email'));
  }

  constructor(private userService: UserService,
    private locationService: LocationService,
    private dialog: MatDialog,
    private registrationService: RegistrationService,
    private globalFlagsService: GlobalFlagsService,
    private storageService: StorageService) {

  }


  ngOnInit() {
    this.getUserDetails().subscribe(() => {
        console.log(this.userDetails);
    if (this.action === UserFormActions.Register) {
      this.modifyPasswordString = 'true';
      const diagnostics = from(this.registrationService.getDiagnostics());
      diagnostics
        .subscribe(() => {
          this.diagnosticsArray = diagnostics;
          this.globalFlagsService.displayLoad(false);
        });
    } else {
      this.usernameExists = true;
    }
    if (!this.registerAction) {
      const countries = from(this.locationService.getCountries());
      countries
        .subscribe(() => {
          this.countries = countries;
          this.globalFlagsService.displayLoad(false);
        });
      const states = from(this.locationService.getStates());
      states
        .subscribe((res) => {
          this.states = res;
          this.countryChanged(this.userDetails.address.country.idCountry);
        });
      const regions = from(this.locationService.getRegions());
      regions
        .subscribe((res) => {
          this.regions = res;
        });
      const languages = from(this.locationService.getLanguages());
      languages
        .subscribe((res) => {
          this.languages = res;
        },
        (err) => {

        });
    }
    });
  }

  getUserDetails() : Observable<any>{
    this.globalFlagsService.displayLoad(true);
    return from(this.userService.getUserInfo())
      .pipe(
        tap((res) => {
          this.userDetails = res;
          this.globalFlagsService.displayLoad(false);
        }),
        catchError((err) => {
          throw err;
        })
      );
  }

  cleanPasswords() {
    this.userDetails.confirmPassword = '';
    this.userDetails.secMemberships[0].oldPassword = '';
    this.userDetails.secMemberships[0].password = '';
  }

  showModal() {
    this.dialog.open(DialogChangePassword, {data: {userDetails:this.userDetails}});
  }

  checkPasswordError(passwordErrors, id) {
    for (const key in passwordErrors) {
      if (passwordErrors.hasOwnProperty(key)) {
        if (passwordErrors[key].id === id) {
          return 'invalid';
        }
      }
    }
  }

  countryChanged(id: any) {
    if (id !== 221) {
      this.userDetails.address.state.idState = '';
      this.disableStates = true;
    } else {
      this.userDetails.address.province = '';
      this.disableStates = false;
    }
  }

  onSaveUser() {
    this.globalFlagsService.displayLoad(true);
    let saveUser;

    // REWORK THIS
    const formUser = JSON.parse(JSON.stringify(this.userDetails));
    if (this.userDetails.confirmPassword === '' && this.userDetails.secMemberships[0].password === '') {
      delete formUser.secMemberships;
    }

    if (this.action === UserFormActions.Edit) {
      saveUser = from(this.userService.saveUser(formUser));
    } else if (this.action === UserFormActions.Register) {
      saveUser = from(this.registrationService.saveRegistration(formUser));
    } else {
      return false;
    }

    saveUser
      .subscribe((res) => {
        this.globalFlagsService.displayLoad(false);
            this.onSubmitSuccess.emit(true);
      }, (err) => {
        this.globalFlagsService.displayLoad(false);
        const message = err.errors[0] === 'secMemberships[].oldPassword: oldpassword' ?
          'Current password is wrong. Please try again.'
          : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
        const data = { message };
        this.dialog.open(DialogComponent, { data });
      });
  }

  isCustomFieldValid(key: string, typeCustomField: any) {
    let customField = null;
    Object.keys(this.userDetails.clinic.customsFieldsPerClinic).forEach(i => {
      if (this.userDetails.clinic.customsFieldsPerClinic[i].customField.key === key) {
         customField = this.userDetails.clinic.customsFieldsPerClinic[i];
         return false;
      }
    });
    if(customField){
      switch(typeCustomField){
        case this.CUSTOM_FIELD_REQUIRED:
          return customField.required;
        case this.CUSTOM_FIELD_DISABLE:
          return customField.disabled;
        case this.CUSTOM_FIELD_HIDE:
          return customField.hide;
      }
    } else {
      return false;
    }
  }

  refresh(): void {
    window.location.reload();
  }
}
